import { Outlet } from 'react-router';

import AppShellHeader from '@cartwhl/ui/layout/AppShellHeader';

export default function PageLayout() {
  return (
    <div className="bg-primary flex min-h-screen flex-col">
      <AppShellHeader />
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
